// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"beu_a bhs_sl","StrollerBoxWidget__imageCounselling":"beu_b bhs_jz"};